function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { GeoJSON, useMap } from '@manifesto-tech/react-leaflet';
import React, { useEffect, useRef, useState } from 'react';
import * as turf from '@turf/turf';
import L from 'leaflet';
var MapBoundary = function MapBoundary(_ref) {
  var locationData = _ref.locationData;
  var globalRect = [[-172.96875, -85.051129], [-172.96875, 85.051129], [205.3125, 85.051129], [205.3125, -85.051129], [-172.96875, -85.051129]];
  var map = useMap();
  var boundaryLayer = useRef(null);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    bounds = _useState2[0],
    setBounds = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    boundaryInvert = _useState4[0],
    setBoundaryInvert = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    boundaryGeoData = _useState6[0],
    setBoundaryGeoData = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    loadingInitialGeoData = _useState8[0],
    setLoadingInitialGeoData = _useState8[1];
  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    loadingBoundaryInvert = _useState10[0],
    setLoadingBoundaryInvert = _useState10[1];
  var _useState11 = useState(setTimeout(function () {
      return false;
    })),
    _useState12 = _slicedToArray(_useState11, 2),
    resizeEnd = _useState12[0],
    setResizeEnd = _useState12[1];
  var resetView = function resetView() {
    var zoomStart = map.getZoom();
    var minZoom = zoomStart - 0.1;
    map.fitBounds(bounds);
    map.setMaxBounds(bounds);
    map.setMinZoom(minZoom);
    map.setZoom(zoomStart);
  };
  useEffect(function () {
    if (Object.keys(locationData.features).length > 0) {
      var coordinates = [];
      turf.featureEach(locationData, function (feature, featureIndex) {
        var featureType = turf.getType(feature);
        if (featureType === 'Polygon') {
          setBoundaryGeoData(feature);
          coordinates = turf.getCoords(feature);
        }
      });
    }
  }, [locationData]);
  useEffect(function () {
    if (boundaryGeoData !== null && boundaryGeoData !== void 0 && boundaryGeoData.geometry) {
      setLoadingInitialGeoData(false);
    }
  }, [boundaryGeoData]);
  useEffect(function () {
    if (!loadingInitialGeoData) {
      if (boundaryLayer.current) {
        setBounds(boundaryLayer.current.getBounds());
      }
    }
  }, [loadingInitialGeoData]);
  useEffect(function () {
    if (Object.keys(bounds).length > 0) {
      var boundaryRect = L.rectangle(globalRect).toGeoJSON();
      resetView();
      if (boundaryRect.geometry && boundaryGeoData.geometry) {
        var boundaryRectPolygon = turf.getGeom(boundaryRect);
        var boundaryLayerPolygon = turf.getGeom(boundaryGeoData);
        var diff = turf.difference(boundaryRectPolygon, boundaryLayerPolygon);
        setBoundaryInvert(diff);
      }
      if (map) {
        map.on('resize', function () {
          clearTimeout(resizeEnd);
          setResizeEnd(setTimeout(function () {
            resetView();
          }, 500));
        });
      }
    }
  }, [bounds]);
  useEffect(function () {
    if (boundaryInvert.geometry) {
      setLoadingBoundaryInvert(false);
      setBoundaryGeoData(boundaryInvert);
    }
  }, [boundaryInvert]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !loadingBoundaryInvert && /*#__PURE__*/React.createElement(GeoJSON, {
    data: boundaryInvert,
    pathOptions: {
      fillColor: 'black',
      fillOpacity: 0.4,
      stroke: 0
    }
  }), !loadingInitialGeoData && /*#__PURE__*/React.createElement(GeoJSON, {
    ref: boundaryLayer,
    data: boundaryGeoData,
    pathOptions: {
      fillOpacity: 0,
      stroke: 0
    }
  }));
};
export default MapBoundary;